/* @flow */
import React from 'react';
import TextField from 'material-ui/TextField';
import Chip from 'material-ui/Chip';
import { graphql, createFragmentContainer } from 'react-relay';

import TimeSlot from './TimeSlot';

import type { JobRequestHeader_request } from './__generated__/JobRequestHeader_request.graphql';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  left: {
    width: '50%',
  },
  right: {
    width: '50%',
  },
};

type Props = {
  request: JobRequestHeader_request,
};

const JobRequestHeader = ({ request }: Props) => (
  <div style={styles.container}>
    <div style={styles.left}>
      <form>
        <TextField
          floatingLabelText="Status"
          value={request.status}
          floatingLabelFixed
          readOnly
        />
        <br />
        <TextField
          floatingLabelText="Request Type"
          value={request.requestType}
          floatingLabelFixed
          readOnly
        />
        <br />
        <TextField
          floatingLabelText="Grade"
          value={request.grade.name}
          floatingLabelFixed
          readOnly
        />
        <br />
        <TextField
          floatingLabelText="Subject"
          value={request.subject.name}
          floatingLabelFixed
          readOnly
        />
        <br />
        <h4>Time Slots</h4>
        {request.sessions.map(({ timeSlots }) =>
          timeSlots.map(timeSlot => (
            <div style={{ padding: 5 }}>
              <Chip key={timeSlot.id}>
                <TimeSlot timeSlot={timeSlot} />
              </Chip>
            </div>
          ))
        )}
      </form>
    </div>
    <div style={styles.right}>
      <img
        alt="Student"
        width={300}
        src={request.student.profilePictureThumbnailUri}
      />
    </div>
  </div>
);

export default createFragmentContainer(JobRequestHeader, {
  request: graphql`
    fragment JobRequestHeader_request on JobRequest {
      status
      requestType
      student {
        firstname
        lastname
        profilePictureThumbnailUri
      }
      grade {
        name
      }
      subject {
        name
      }
      totalRateStudent
      totalRateTutor
      createdAt
      openJobOffersCount
      sessions {
        timeSlots {
          id
          ...TimeSlot_timeSlot
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/job/components/JobRequestHeader.js